import React from "react";
import { deleteAddress, fetchAddresses } from "../../Services/MainService";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Card from "react-bootstrap/Card";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import { AddAddress } from "./AddAddress";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";

export const AddressPicker = ({
  onSelect,
  closeButton = false,
  show = false,
  onHide = null,
  title = "",
  titleStyle = {},
  editOnSelect = false,
  showEdit = true,
  showDelete = true,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [fetchFailed, setFetchFailed] = React.useState(false);
  const [address, setAddress] = React.useState([]);
  const [atd, setATD] = React.useState(null);
  const [deleting, setDeleting] = React.useState(false);
  const [showAdd, setShowAdd] = React.useState(false);
  const zone = useSelector((x) => x.Zone);
  const [addy, setAddy] = React.useState(null);
  const loggedIn = useSelector((x) => x.LoggedIn);
  const [search, setSearch] = React.useState("");

  const fetchAddress = () => {
    setLoading(true);
    setFetchFailed(false);
    fetchAddresses().then(
      (res) => {
        setLoading(false);
        setAddress(res);
      },
      (er) => {
        setLoading(false);
        setFetchFailed(true);
        toast.error("Something wert wrong while fetching your addresses...");
      }
    );
  };

  React.useEffect(() => {
    if (loggedIn && show) {
      fetchAddress();
    }
  }, [loggedIn, show]);
  const DeleteAddress = () => {
    if (atd) {
      setDeleting(true);
      deleteAddress(atd.id).then(
        () => {
          setAddress((x) => x.filter((y) => y.id !== atd.id));
          toast.success("Address Deleted Successfully...");
          setDeleting(false);
          setATD(null);
        },
        () => {
          setDeleting(false);
          setATD(null);
          toast.error("Something went wrong while deleting the address...");
        }
      );
    } else {
      setATD(null);
    }
  };
  const handleAddAddress = (e) => {
    // console.log(e, "handleAddAddress");
    // setAddress((x) => {
    //   const ary = [...x];
    //   const i = ary.findIndex((y) => y.id === e.id);
    //   if (~i) {
    //     ary[i] = e;
    //   } else ary.push(e);
    //   return ary;
    // });
    fetchAddress();
    setShowAdd(false);
  };
  const handleSelect = (e) => {
    const payload = {
      ...e,
      zone_id: e.zone_id || e.zoneId,
      laundry_zone_id: e.laundry_zone_id || e.laundryZoneId,
    };
    if (onSelect) {
      onSelect(payload);
    }
    if (editOnSelect) {
      handleEdit(payload);
    }
  };
  const handleEdit = (x) => {
    const payload = {
      ...x,
      area_id: x.area?.[0]?.id,
      area_phase_id: x.phase?.[0]?.id,
      zone_id: x.zone_id || x.zoneId,
      laundry_zone_id: x.laundry_zone_id || x.laundryZoneId,
      zoneId: x.zoneId || x.zone_id,
      laundryZoneId: x.laundryZoneId || x.laundry_zone_id,
      cords: {
        lat: parseFloat(x.latitude), // Default latitude (e.g., Karachi)
        lng: parseFloat(x.longitude), // Default longitude (e.g., Karachi)
      },
    };
    setAddy(payload);
    setShowAdd(true);
  };

  // Helper outside component
const getAddressStyle = (type = "") => {
  const t = type.toLowerCase();
  if (t.includes("home"))    return { bg: "#E8F5E9", color: "#43A047", icon: "fa-house" };
  if (t.includes("work") || t.includes("office")) return { bg: "#EDE7F6", color: "#7B1FA2", icon: "fa-briefcase" };
  if (t.includes("gym"))     return { bg: "#FFF3E0", color: "#E65100", icon: "fa-dumbbell" };
  if (t.includes("other"))   return { bg: "#F3F4F6", color: "#555", icon: "fa-grip" };
  return { bg: "#E3F2FD", color: "#1565C0", icon: "fa-location-dot" };
};

  return (
    <>
      {/* <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => {
          if (onHide) onHide();
        }}
      >
        <Modal.Header closeButton={closeButton} className="py-2">
          <Modal.Title style={{ ...titleStyle, fontSize: "18px" }}>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="col-12 text-center">
              <Spinner size="lg" variant="primary" />
            </div>
          ) : address.length !== 0 ? (
            address.map((x, i) => (
              <Card
                className={`${i !== address.length - 1 ? "mb-2" : ""}`}
                key={i}
              >
                <Card.Body>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <p
                      className="text-capitalize fw-semibold mb-0 cursor-pointer"
                      style={{ fontSize: "19px" }}
                      onClick={() => handleSelect(x)}
                    >
                      {x.address_type}
                    </p>
                    <div>
                      {showEdit ? (
                        <span
                          className="cursor-pointer text-secondary me-2"
                          onClick={() => handleEdit(x)}
                        >
                          <i className="fa-solid fa-pencil "></i>
                        </span>
                      ) : null}
                      {showDelete ? (
                        <span
                          className="cursor-pointer text-danger me-2"
                          onClick={() => setATD(x)}
                        >
                          <i className="fa-solid fa-trash-alt"></i>
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <span
                    className="hide-extra-text cursor-pointer"
                    style={{ fontSize: "16px" }}
                    onClick={() => handleSelect(x)}
                  >
                    {x.address1}, {x.address2},{" "}
                    {x.area?.[0] ? `${x.area?.[0]?.name},` : null}{" "}
                    {x.phase?.[0] ? `${x.phase?.[0]?.name},` : null}
                  </span>
                </Card.Body>
              </Card>
            ))
          ) : (
            <>
              <div className="col-12 text-center text-muted">
                No addresses found...
              </div>
            </>
          )}
          <button
            className="btn btn-primary w-100 fw-semibold text-dark mt-3"
            onClick={() => setShowAdd(true)}
          >
            Add New Address
          </button>
          <ConfirmationModal
            show={Boolean(atd)}
            text="Are your sure you want to delete this address?"
            onYes={() => DeleteAddress()}
            onNo={() => setATD(null)}
            yesLoading={deleting}
          />
          <AddAddress
            show={showAdd}
            onHide={() => setShowAdd(false)}
            onAdd={handleAddAddress}
            addy={addy}
          />
        </Modal.Body>
      </Modal> */}
      

<Modal
  show={show}
  backdrop="static"
  keyboard={false}
  centered
  onHide={() => { if (onHide) onHide(); }}
>
  <Modal.Header closeButton={closeButton} style={{ border: "none", paddingBottom: "0" }}>
  <div className="d-flex align-items-center gap-3">
    <div style={{ background: "#FFF8EC", borderRadius: "50%", width: "44px", height: "44px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <i className="fa-solid fa-location-dot" style={{ color: "#F5A623", fontSize: "20px" }}></i>
    </div>
    <div>
      <Modal.Title style={{ ...titleStyle, fontSize: "17px", fontWeight: "700", color: "#111" }}>
        {title}  {/* 👈 dynamic */}
      </Modal.Title>
      {/* no subtitle prop in original so hardcoded */}
      <p className="mb-0" style={{ fontSize: "12px", color: "#888" }}>Choose from your saved addresses</p>
    </div>
  </div>
  </Modal.Header>

  <Modal.Body style={{ paddingTop: "16px" }}>

    {/* Search + Add */}
    <div className="d-flex gap-2 mb-3">
      <div className="d-flex align-items-center flex-grow-1 px-3" style={{ border: "1px solid #E5E5E5", borderRadius: "10px", height: "44px" }}>
        <i className="fa-solid fa-magnifying-glass me-2" style={{ color: "#aaa", fontSize: "13px" }}></i>
        <input
          type="text"
          placeholder="Search your area or address..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ 
            border: "none", 
            outline: "none", 
            width: "100%", 
            fontSize: "13px", 
            color: "#333", 
            background: "transparent" 
          }}
        />
      </div>
      <button
        onClick={() => setShowAdd(true)}
        style={{ border: "1.5px solid #2E7D32", borderRadius: "10px", background: "transparent", color: "#2E7D32", fontWeight: "600", fontSize: "13px", padding: "0 14px", whiteSpace: "nowrap" }}
      >
        + Add new address
      </button>
    </div>

    {/* Address List */}
    {loading ? (
      <div className="col-12 text-center py-3">
        <Spinner size="lg" variant="primary" />
      </div>
    ) : address.length !== 0 ? (
      address
    .filter(x =>
      x.address_type?.toLowerCase().includes(search.toLowerCase()) ||
      x.address1?.toLowerCase().includes(search.toLowerCase())
    ).map((x, i) => {
        const { bg, color, icon } = getAddressStyle(x.address_type);
        return (
          <div
            key={i}
            onClick={() => handleSelect(x)}
            style={{ 
              display: "flex", 
              alignItems: "center", 
              gap: "14px", 
              padding: "8px 8px",
              border: "1px solid #E5E5E5",
              borderRadius: "10px",
              cursor: "pointer", 
              // borderBottom: i !== address.length - 1 ? "1px solid #F0F0F0" : "none", 
              marginBottom: i !== address.length - 1 ? "8px" : "0", 
            }}
          >
            {/* Icon */}
            <div style={{ background: bg, borderRadius: "10px", width: "42px", height: "42px", minWidth: "42px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <i className={`fa-solid ${icon}`} style={{ color, fontSize: "16px" }}></i>
            </div>

            {/* Text */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <p className="mb-0 fw-semibold text-capitalize" style={{ fontSize: "15px", color: "#111" }}>{x.address_type}</p>
              <p className="mb-0 text-truncate" style={{ fontSize: "13px", color: "#888" }}>
                {x.address1}, {x.address2},{" "}
                {x.area?.[0] ? `${x.area[0].name},` : null}{" "}
                {x.phase?.[0] ? `${x.phase[0].name}` : null}
              </p>
            </div>

            {/* Actions + Chevron */}
            <div className="d-flex align-items-center gap-2">
              {showEdit && (
                <span onClick={(e) => { e.stopPropagation(); handleEdit(x); }} 
                style={{ 
                  background: "#EEF3FB",
                  borderRadius: "8px",
                  padding: "6px 8px",
                  color: "#2E5BA8",
                  fontSize: "13px",
                  cursor: "pointer" 
                  }}
                  >
                  <i className="fa-solid fa-pencil"></i>
                </span>
              )}
              {showDelete && (
                <span onClick={(e) => { e.stopPropagation(); setATD(x); }} 
                style={{ 
                  background: "#FFEEEE",
                  borderRadius: "8px",
                  padding: "6px 8px",
                  color: "#E53935",
                  fontSize: "13px",
                  cursor: "pointer" 
                  }}
                  >
                  <i className="fa-solid fa-trash-alt"></i>
                </span>
              )}
              <i className="fa-solid fa-chevron-right" style={{ color: "#ccc", fontSize: "13px" }}></i>
            </div>
          </div>
        );
      })
    ) : fetchFailed ? (
      <div className="col-12 text-center text-muted py-3">
        <p className="mb-2">Failed to load addresses.</p>
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={fetchAddress}>Retry</button>
      </div>
    ) : (
      <div className="col-12 text-center text-muted py-3">No addresses found...</div>
    )}

    <ConfirmationModal
      show={Boolean(atd)}
      text="Are your sure you want to delete this address?"
      onYes={() => DeleteAddress()}
      onNo={() => setATD(null)}
      yesLoading={deleting}
    />
    {showAdd ? <AddAddress
      show={showAdd}
      onHide={() => setShowAdd(false)}
      onAdd={handleAddAddress}
      addy={addy}
    /> : null}
  </Modal.Body>
</Modal>
    </>
  );
};
